import { Controller, Control } from 'react-hook-form';
import { FormControl, FormHelperText, Switch, SwitchProps, Typography } from '@mui/material';

type ControlledSwitchProps = SwitchProps & {
  control: Control<any, any>;
  name: string;
  required?: boolean;
  label?: string;
  errorMessage?: string;
};

export const ControlledSwitch = ({
  control,
  name,
  required,
  label,
  errorMessage,
  ...props
}: ControlledSwitchProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { onChange, value = false }, fieldState: { error } }) => (
        <FormControl error={Boolean(error)} sx={{ display: 'flex', alignItems: 'center' }}>
          {label && <Typography variant="body2">{label}</Typography>}
          <Switch checked={value} onChange={(e) => onChange(e.target.checked)} {...props} />
          {error && errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
